import { doc, getDoc } from "firebase/firestore";
import { SyncStatus } from "../../Resources/Constants";
import { makeAutoObservable } from "mobx";
import db from "../Firestore/FirestoreConfig";

class ImageMessageManager {
  static instance = null;

  showingChatMediaPlayer = false;

  videoURL = null;

  constructor() {
    if (ImageMessageManager.instance) {
      return ImageMessageManager.instance;
    }
    ImageMessageManager.instance = this;
    makeAutoObservable(this);
  }

  static getInstance() {
    if (!ImageMessageManager.instance) {
      ImageMessageManager.instance = new ImageMessageManager();
    }
    return ImageMessageManager.instance;
  }

  setVideoURL(url) {
    this.videoURL = url;
  }

  setShowingChatMediaPlayer(show) {
    this.showingChatMediaPlayer = show;
  }
}

export default ImageMessageManager;
